import React, { useEffect, useState } from "react";
import { CardContainer } from "../../components/Card/CardContainer";
import { Alert, Col, Divider, Form, Modal, Row, Spin, Image } from "antd";
import PageTitleNested from "../../components/PageTitle/PageTitleNested";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import StepAntd from "../../components/StepAntd/StepAntd";
import Button from "../../components/Button/Button";
import { FlashSaleStepOne } from "./CreateFlashSaleStep/FlashSaleStepOne";
import { FlashSaleStepTwo } from "./CreateFlashSaleStep/FlashSaleStepTwo";
import { FlashSaleStepThree } from "./CreateFlashSaleStep/FlashSaleStepThree";
import { FlashSaleStepFour } from "./CreateFlashSaleStep/FlashSaleStepFour";
import {
  createStepFive,
  createStepOne,
  createStepThree,
  createStepTwo,
  getFlashSaleById,
} from "../../datasource/FlashSaleDatasource";
import dayjs from "dayjs";
import { FlashSaleStepFive } from "./CreateFlashSaleStep/FlashSalleStepFive";
import Text from "../../components/Text/Text";
import { color, image } from "../../resource";
import { checkShopHighlight, createHighlightFlashSale } from "../../datasource/News";
import { FlexCol, FlexRow } from "../../components/Container/Container";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useMessageContext } from "../../context/MessageProvider";

export const CreateFlashSale: React.FC = () => {
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const navigate = useNavigate();
  const { messageApi } = useMessageContext();
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const isCreate = pathSplit[3] === "0";
  const id = pathSplit[3];
  const navigateType = pathSplit[4];
  const [step, setStep] = useState(0);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [modalConfirm, setModalConfirm] = useState(false);
  const [validateStepFour, setValidateStepFour] = useState(false);
  const [modalHighlightDup, setModalHighlightDup] = useState<any>({ open: false, data: [] });

  const setLoadingEnd = () => {
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const fetchData = async () => {
    setLoading(true);
    await getFlashSaleById(id).then((data) => {
      form.setFieldsValue({
        flashSaleId: data.flashSaleId,
        company: data.company,
        flashSaleName: data.flashSaleName,
        promotionCode: data.promotionCode,
        fileImage: data.coverImage,
        fileImageUrl: data.coverImageUrl,
        productBrandId: `${data.productBrandId}`,
        productBrandName: data.productBrandName,
        fileMemo: data.refFile,
        fileMemoUrl: data.refFileUrl,
        mainStartDate: data.startDate ? dayjs(data.startDate) : undefined,
        mainEndDate: data.endDate ? dayjs(data.endDate) : undefined,
        cartLockTime: data.cartLockTime,
        isFreeShip: data.isFreeShip,
        prelaunchPreview: data.prelaunchPreview,
        previewDate: data.previewDate ? dayjs(data.previewDate) : undefined,
        previewTime: data.previewDate ? dayjs(data.previewDate) : undefined,
        rounds:
          data.rounds && data.rounds.length > 0
            ? data.rounds.map((round: any) => ({
                ...round,
                startDate: round.startDate ? dayjs(round.startDate) : undefined,
                endDate: round.endDate ? dayjs(round.endDate) : undefined,
                startTime: round.startDate ? dayjs(round.startDate) : undefined,
                endTime: round.endDate ? dayjs(round.endDate) : undefined,
                products: [],
                searchProducts: [],
              }))
            : [],
        status: data.status,
        fileImageHightLight: data.highLightImage,
        fileImageHightLightUrl: data.highLightImageUrl,
        highLightNewsId: data.highLightNewsId,
        isSendNav: data.isSendNav || false,
      });
    });
    setLoadingEnd();
  };

  useEffect(() => {
    if (!isCreate && id) {
      fetchData();
    }
  }, [isCreate, form]);

  const PageTitle = () => {
    return (
      <PageTitleNested
        title={isCreate ? "สร้าง Flash Sale" : "แก้ไข Flash Sale"}
        showBack
        onBack={() => {
          id === "0"
            ? navigate(`/PromotionPage/flashSale`)
            : navigate(`/PromotionPage/detailFlashSale/${id}/detail`);
        }}
        extra={
          <>
            <StepAntd
              current={step}
              items={[
                {
                  title: "ข้อมูลเบื้องต้น",
                },
                {
                  title: "วันและรอบเวลา",
                },
                {
                  title: "ร้านค้า",
                },
                {
                  title: "สินค้า",
                },
                {
                  title: "ตรวจสอบ",
                },
              ]}
            />
          </>
        }
        customBreadCrumb={
          <BreadCrumb
            data={[
              ...(step === 0
                ? [
                    { text: "ตั้งค่าโปรโมชัน Flash Sale", path: "/PromotionPage/flashSale" },
                    ...(navigateType === "edit"
                      ? [
                          {
                            text: "รายละเอียด Flash Sale",
                            path: `/PromotionPage/detailFlashSale/${id}/detail`,
                          },
                        ]
                      : []),
                  ]
                : []),
              {
                text: isCreate ? "สร้าง Flash Sale" : "แก้ไข Flash Sale",
                path: -1,
              },
            ]}
          />
        }
      />
    );
  };

  const renderStep = () => {
    switch (step) {
      case 0:
        return <FlashSaleStepOne form={form} />;
      case 1:
        return <FlashSaleStepTwo form={form} />;
      case 2:
        return <FlashSaleStepThree form={form} company={profile.company} />;
      case 3:
        return (
          <FlashSaleStepFour
            form={form}
            company={profile.company}
            setValidateStepFour={setValidateStepFour}
          />
        );
      case 4:
        return <FlashSaleStepFive form={form} />;
      default:
        return null;
    }
  };

  const onNext = async () => {
    if (step === 0) {
      try {
        await form.validateFields();
        setLoading(true);
        const dataForm = {
          ...form.getFieldsValue(true),
          updateBy: profile.firstname + " " + profile.lastname,
        };
        await createStepOne(
          dataForm,
          dataForm.fileImage,
          dataForm.fileMemo,
          dataForm.fileImageHightLight,
        ).then((res) => {
          if (res.success) {
            form.setFieldsValue({ ...dataForm, flashSaleId: res.responseData.flashSaleId });
            setStep(step + 1);
            setLoadingEnd();
            navigate(`/PromotionPage/flashSale/${res.responseData.flashSaleId}/edit`);
          }
        });
      } catch (error) {
        console.log("error step 1", error);
      }
    } else if (step === 1) {
      try {
        await form.validateFields();
        setLoading(true);
        const dataForm = form.getFieldsValue(true);
        const startDate = `${dayjs(dataForm.mainStartDate).format("YYYY-MM-DD")} ${dayjs(dataForm.rounds[0].startTime).format("HH:mm:ss")}`;
        const endDate = `${dayjs(dataForm.mainEndDate).format("YYYY-MM-DD")} ${dayjs(dataForm.rounds[dataForm.rounds.length - 1].endTime).format("HH:mm:ss")}`;

        const payload = {
          flashSaleId: id || dataForm.flashSaleId,
          startDate: dayjs(startDate).toISOString(),
          endDate: dayjs(endDate).toISOString(),
          prelaunchPreview: dataForm.prelaunchPreview,
          previewDate: dayjs(
            `${dayjs(`${dataForm.previewDate}`).format("YYYY-MM-DD")} ${dayjs(`${dataForm.previewTime}`).format("HH:mm:ss")}`,
          ).toISOString(),
          round: dataForm.rounds.map((round: any) => ({
            roundNo: round.roundNo,
            startDate: dayjs(
              `${dayjs(`${round.startDate}`).format("YYYY-MM-DD")} ${dayjs(`${round.startTime}`).format("HH:mm:ss")}`,
            ).toISOString(),
            endDate: dayjs(
              `${dayjs(`${round.endDate}`).format("YYYY-MM-DD")} ${dayjs(`${round.endTime}`).format("HH:mm:ss")}`,
            ).toISOString(),
          })),
          updateBy: profile.firstname + " " + profile.lastname,
        };
        await createStepTwo(payload).then((res) => {
          if (res.success) {
            form.setFieldsValue({
              ...dataForm,
              mainStartDate: startDate,
              mainEndDate: endDate,
              rounds: res.responseData.rounds.map((round: any) => ({
                ...round,
                startDate: dayjs(round.startDate),
                endDate: dayjs(round.endDate),
                startTime: dayjs(round.startDate),
                endTime: dayjs(round.endDate),
                products:
                  dataForm.rounds.find((r: any) => r.roundNo === round.roundNo)?.products || [],
                searchProducts:
                  dataForm.rounds.find((r: any) => r.roundNo === round.roundNo)?.products || [],
              })),
            });
            setLoadingEnd();
            setStep(step + 1);
          }
        });
      } catch (error) {
        console.log("error step 2", error);
      }
    } else if (step === 2) {
      setLoading(true);
      const dataForm = form.getFieldsValue(true);
      const payload = {
        flashSaleId: id || dataForm.flashSaleId,
        shops: dataForm.shops.map((shop: any) => ({
          customerCompanyId: shop.customerCompanyId,
          customerName: shop.customerName,
          customerNo: shop.customerNo,
          zone: shop.zone,
          customerGroupId: shop.customerGroupId,
          customerGroupName: shop.customerGroupName,
          termPayment: shop.termPayment,
        })),
        updateBy: profile.firstname + " " + profile.lastname,
      };
      await createStepThree(payload).then((res) => {
        if (res.success) {
          form.setFieldsValue({
            ...dataForm,
            shops: res.responseData.shops,
            searchShop: res.responseData.shops,
          });
          setStep(step + 1);
        }
        setLoadingEnd();
      });
    } else if (step === 3) {
      setLoading(true);
      setStep(step + 1);
      setLoading(false);
    } else if (step === 4) {
      setModalConfirm(true);
    }
  };

  const onPrev = () => {
    if (step > 0) {
      fetchData();
    }
    setValidateStepFour(false);
    setLoadingEnd();
    setStep(step - 1);
  };

  const updateFlashSale = async (highlightNewsId?: string) => {
    await createStepFive({
      flashSaleId: id || form.getFieldValue("flashSaleId"),
      updateBy: profile.firstname + " " + profile.lastname,
      highLightNewsId: highlightNewsId || undefined,
    }).then((res) => {
      if (res.success) {
        setModalConfirm(false);
        messageApi.success("บันทึกสำเร็จ");
        navigate("/PromotionPage/flashSale");
      }
    });
  };

  const onApproveFlashSale = async () => {
    const dataForm = form.getFieldsValue(true);
    let isHighLightDup: any = { isDup: false, data: [] };
    if (dataForm.isHighLight) {
      setModalConfirm(false);
      const checkDup = await checkDuplicateHighlight(
        dataForm.previewDate,
        dataForm.mainEndDate,
        form.getFieldValue("shops") || [],
        form.getFieldValue("highLightNewsId") || null,
      );
      const groupedNew =
        checkDup?.length > 0
          ? checkDup.reduce((acc: any, item: any) => {
              const key = item.highlightNews.highlightNewsId;
              if (!acc[key]) {
                acc[key] = {
                  ...item.highlightNews,
                  shops: [],
                };
              }
              acc[key].shops.push({
                highlightNewsShopId: item.highlightNewsShopId,
                customerCompanyId: item.customerCompanyId,
                customerNo: item.customerNo,
                customerName: item.customerName,
                zone: item.zone,
                customerGroupName: item.customerGroupName,
              });
              return acc;
            }, {})
          : {};
      const DupNewsList = Object.values(groupedNew);
      isHighLightDup = { isDup: checkDup?.length > 0, data: DupNewsList || [] };
      isHighLightDup.isDup
        ? setModalHighlightDup({ open: true, data: isHighLightDup.data })
        : onCreateHighlight("PUBLISHED");
    } else {
      updateFlashSale();
    }
  };

  const onCreateHighlight = async (status: string) => {
    const dataForm = form.getFieldsValue(true);
    const mapShopData =
      dataForm.shops.map((shop: any) => ({
        newsShopId: shop.newsShopId,
        customerCompanyId: shop.customerCompanyId,
        customerNo: shop.customerNo,
        customerName: shop.customerName,
        zone: shop.zone,
        customerGroupName: shop.customerGroupName,
      })) || [];

    const formData = new FormData();
    dataForm.highLightNewsId && formData.append("highlightNewsId", dataForm.highLightNewsId);
    formData.append("image", dataForm.fileImageHightLightUrl);
    formData.append("company", dataForm.company);
    formData.append("topic", dataForm.flashSaleName);
    formData.append(
      "startDate",
      dayjs(
        `${dayjs(dataForm.previewDate).format("YYYY-MM-DD")} ${dayjs(dataForm.previewTime).format("HH:mm")}`,
      ).toISOString(),
    );
    formData.append(
      "endDate",
      dayjs(
        `${dayjs(dataForm.mainEndDate).format("YYYY-MM-DD")} ${dayjs(dataForm.mainEndDate).format("HH:mm")}`,
      ).toISOString(),
    );
    formData.append("isShowOnSaleApp", "true");
    formData.append("isShowOnShopApp", "true");
    formData.append("newsShops", JSON.stringify(JSON.stringify(mapShopData)));
    formData.append("status", status);
    formData.append("createdBy", profile.firstname + " " + profile.lastname);
    formData.append("updateBy", profile.firstname + " " + profile.lastname);
    formData.append("flashSaleId", dataForm.flashSaleId);

    await createHighlightFlashSale(formData)
      .then((res) => {
        if (res.success) {
          updateFlashSale(res.responseData.highlightNewsId);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <CardContainer>
        <PageTitle />
        <Divider size='small' />
        <br />
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "40vh",
            }}
          >
            <Spin size='large' />
          </div>
        ) : (
          <>
            <div style={{ padding: "10px" }}>{renderStep()}</div>
            <Divider size='small' />
            <Row justify='space-between' gutter={12} style={{ paddingTop: "10px" }}>
              <Col span={3}>
                {step > 0 && (
                  <Button typeButton='primary-light' title='ย้อนกลับ' onClick={onPrev} />
                )}
              </Col>
              <br />
              {!validateStepFour && (
                <Col span={4}>
                  <Button
                    typeButton='primary'
                    title={step === 4 ? "บันทึกและส่งอนุมัติ" : "บันทึกแบบร่างและถัดไป"}
                    onClick={onNext}
                  />
                </Col>
              )}
            </Row>
          </>
        )}
      </CardContainer>
      {modalConfirm && (
        <Modal
          maskClosable={false}
          open={modalConfirm}
          onOk={onApproveFlashSale}
          onCancel={() => setModalConfirm(false)}
          width={600}
          centered
          cancelText='ยกเลิก'
          okText='ยืนยัน'
          okButtonProps={{
            style: {
              backgroundColor: color.primary,
              borderColor: color.primary,
            },
          }}
          cancelButtonProps={{
            style: {
              borderColor: color.primary,
              color: color.primary,
            },
          }}
        >
          <Text level={2} fontWeight={600}>
            ยืนยันบันทึกการสร้าง Flash Sale และรออนุมัติ
          </Text>
          <br />
          <Text color='Text3'>
            เมื่อบันทึกการแก้ไข Flash Sale แล้ว{" "}
            <Text color='warning'>ต้องให้ผู้มีสิทธิ์อนุมัติดำเนินการอนุมัติ</Text>
            <br />
            โปรดตรวจสอบรายละเอียดการตั้งค่าอีกครั้งก่อนกดยืนยัน
          </Text>
          <Divider size='small' />
        </Modal>
      )}
      {modalHighlightDup.open && (
        <HighLightDupList
          data={modalHighlightDup.data}
          modalHighlightDup={modalHighlightDup}
          setModalHighlightDup={setModalHighlightDup}
          path='setting'
          onCreate={(status) => {
            onCreateHighlight(status);
          }}
        />
      )}
    </>
  );
};

export const HighLightDupList: React.FC<{
  data: any;
  modalHighlightDup: any;
  setModalHighlightDup: any;
  onCreate: (status: string) => void;
  path: "setting" | "tab";
}> = ({ data, modalHighlightDup, setModalHighlightDup, onCreate, path }) => {
  const newFlashSaleHighlights = data.filter((item: any) => item.type === "FLASH_SALE");
  const otherHighlights = data.filter((item: any) => item.type !== "FLASH_SALE");

  return (
    <Modal
      open={modalHighlightDup.open}
      onCancel={() => setModalHighlightDup({ open: false, data: [] })}
      centered
      footer={null}
      width={700}
    >
      <FlexCol style={{ alignItems: "center" }}>
        <img
          src={image.errorState}
          alt='errorState'
          style={{ height: "120px", paddingBottom: "10px" }}
        />
        <Text level={3} fontWeight={600}>
          มีบางร้านเปิดใช้งานไฮไลท์ข่าวสารอื่น <br /> อยู่ในช่วงเวลาเดียวกันกับ Flash Sale
        </Text>
      </FlexCol>
      <br />
      <Alert
        icon={<ExclamationCircleOutlined style={{ fontSize: "20px", color: color.warning }} />}
        showIcon
        description={<Text level={6}>1 ร้านค้าสามารถแสดงไฮไลท์ข่าวสารได้แค่ 1 ไฮไลท์</Text>}
        style={{
          padding: "8px",
          borderRadius: "4px",
          border: "none",
          backgroundColor: "#FFF5F5",
          alignItems: "center",
        }}
      />
      <div
        style={{
          paddingTop: "10px",
          maxHeight: "200px",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {newFlashSaleHighlights?.length > 0 && (
          <>
            <Alert
              showIcon={false}
              description={
                <Text level={6} fontWeight={700}>
                  ไฮไลท์ข่าวสาร Flash Sale
                </Text>
              }
              style={{
                padding: "8px",
                borderTopLeftRadius: "4px",
                borderTopRightRadius: "4px",
                border: "none",
                backgroundColor: "#F3F6F9",
                alignItems: "center",
              }}
            />
            {newFlashSaleHighlights?.map((item: any, index: number) => (
              <Row
                key={index}
                justify='start'
                gutter={12}
                style={{ padding: "8px", borderBottom: "1px solid #E4E6EF" }}
              >
                <Col span={8}>
                  <Text level={6}>
                    {dayjs(item.startDate).format("DD/MM/YYYY, HH:mm") +
                      " - " +
                      dayjs(item.endDate).format("DD/MM/YYYY, HH:mm")}
                  </Text>
                </Col>
                <Col span={16}>
                  <FlexRow style={{ alignItems: "center", gap: "10px" }}>
                    <Image
                      src={item.newsImage}
                      height={60}
                      width={60}
                      style={{ borderRadius: "5px", objectFit: "cover" }}
                    />
                    <Text level={5}>{item.topic || "-"}</Text>
                  </FlexRow>
                </Col>
              </Row>
            ))}
          </>
        )}
        {otherHighlights?.length > 0 && (
          <>
            <Alert
              showIcon={false}
              description={
                <Text level={6} fontWeight={700}>
                  ไฮไลท์ข่าวสารอื่น ({otherHighlights?.length})
                </Text>
              }
              style={{
                padding: "8px",
                borderBottomLeftRadius: "4px",
                borderBottomRightRadius: "4px",
                border: "none",
                backgroundColor: "#F3F6F9",
                alignItems: "center",
              }}
            />
            {otherHighlights?.map((item: any, index: number) => (
              <Row
                key={index}
                justify='start'
                gutter={12}
                style={{ padding: "8px", borderBottom: "1px solid #E4E6EF" }}
              >
                <Col span={8}>
                  <Text level={6}>
                    {dayjs(item.startDate).format("DD/MM/YYYY, HH:mm") +
                      " - " +
                      dayjs(item.endDate).format("DD/MM/YYYY, HH:mm")}
                  </Text>
                </Col>
                <Col span={16}>
                  <FlexRow style={{ alignItems: "center", gap: "10px" }}>
                    <Image
                      src={item.newsImage}
                      height={60}
                      width={60}
                      style={{ borderRadius: "5px", objectFit: "cover" }}
                    />
                    <Text level={5}>{item.topic || "-"}</Text>
                  </FlexRow>
                </Col>
              </Row>
            ))}
          </>
        )}
      </div>
      <br />
      {path === "setting" && (
        <>
          <FlexCol style={{ alignItems: "center" }}>
            <Text color='Text3'>คุณสามารถสร้างไฮไลท์ข่าวสาร Flash Sale</Text>
            <Text color='Text3'>ให้ระบบปิดใช้งานไฮไลท์อื่นในช่วงเวลาเดียวกันอัตโนมัติ</Text>
            <Text color='Text3'>หรือสามารถสร้างไฮไลท์ข่าวสาร Flash Sale โดยปิดใช้งานไว้ก่อน</Text>
            <Text color='Text3'>
              เพื่อจัดการไฮไลท์อื่นที่เปิดใช้ช่วงเวลาเดียวกันที่เมนู “ไฮไลท์ข่าวสาร”
            </Text>
          </FlexCol>
          <Divider size='small' />
        </>
      )}

      <Row justify='space-between' gutter={12}>
        {path === "setting" ? (
          <>
            <Col span={12}>
              <Button
                typeButton='primary-light'
                title='สร้างไฮไลท์ Flash Sale แบบปิดใช้งาน'
                onClick={() => {
                  setModalHighlightDup({ open: false, data: [] });
                  onCreate("INACTIVE");
                }}
              />
            </Col>
            <Col span={12}>
              <Button
                typeButton='primary'
                title='สร้างไฮไลท์ Flash Sale และปิดไฮไลท์อื่น'
                onClick={() => {
                  setModalHighlightDup({ open: false, data: [] });
                  onCreate("PUBLISHED");
                }}
              />
            </Col>
          </>
        ) : (
          <Col span={24}>
            <Button
              typeButton='primary'
              title='เปิดไฮไลท์ Flash Sale และปิดไฮไลท์อื่น'
              onClick={() => {
                setModalHighlightDup({ open: false, data: [] });
                onCreate("PUBLISHED");
              }}
            />
          </Col>
        )}
      </Row>
    </Modal>
  );
};

export const checkDuplicateHighlight = async (
  startDate: string,
  endDate: string,
  shopList: any[],
  highLightNewsId?: string,
) => {
  const payloadCheck = {
    highlightNewsId: highLightNewsId || null,
    startDate: dayjs(`${dayjs(startDate).format("YYYY-MM-DD HH:mm")}`).toISOString(),
    endDate: dayjs(`${dayjs(endDate).format("YYYY-MM-DD HH:mm")}`).toISOString(),
    customerCompanyIds: (shopList || []).map((shop: any) => {
      return { customerCompanyId: shop.customerCompanyId };
    }),
  };
  const checkDup = await checkShopHighlight(payloadCheck).then((res) => {
    return res;
  });

  return checkDup;
};
